import { getCurrentInstance } from 'vue';

export default function useAxiosClient() {
  const vue = getCurrentInstance();
  return vue.proxy.axiosClient;
}
